export enum ETemplateType {
    INFINITY = 'infinity',
    SILVER = 'silver',
    TRANSITIONS = 'transitions',
    SAPPHIRE = 'sapphire',
    PIONEER = 'pioneer',
    STUDIO = 'studio'
}
